import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useAlert } from "../../../../Contexts/AlertContext/AlertService";
import { useLoading } from "../../../../providers/loadingProvider";
import { useNotify } from "../../../../providers/NotificationProvider";
import { committeeSelector } from "../../../../store/advisorSlice";
import service from "../../Helpers/gifservices";

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(8),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  autocomplete: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: "100%",
    marginTop: theme.spacing(1),
    "& > *": {
      marginTop: theme.spacing(2),
    },
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  formControl: {

  },
}));

export default function AssignAdvisorDialog(props) {
  const { open, onClose, proposalId, refreshProposals } = props;
  const classes = useStyles();
  const notify = useNotify();
  const alert = useAlert();
  const loading = useLoading();
  const committee = useSelector(committeeSelector);
  const [advisors, setAdvisors] = useState([]);
  const [advisorId, setAdvisor] = useState(null);

  const AssignAdvisor = async () => {
    const loadingId = loading.addLoading("Assigning Advisor To Propsal");
    const committeeId = committee.committeeId;
    const result = await service.AssotiateAdvisorToProposal({advisorId, committeeId, proposalId});
    loading.removeLoading(loadingId);
    if(!result){
        await alert({
          title: "Error Assigning Advisor",
          description: `Sorry there was a problem in assigning advisor to the Propsal`,
        });
      }
      else{
        onClose();
        notify.show("Assigning Advisor completed successfully");
        refreshProposals();
      }
  };

  const getAdvisors = useCallback(async() => {
      if(!committee)return;
      const loadingId = loading.addLoading("loading advisors");
      const committeeId = committee.committeeId
      const advisors = await service.GetCommitteeAdvisors({committeeId});
      setAdvisors(advisors);
      loading.removeLoading(loadingId);
  }, [committee, loading]);

  useEffect(() => {
      if(!open)return;
    getAdvisors();
  }, [getAdvisors, open]);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="form-dialog-title"
    >
      <DialogTitle id="form-dialog-title">
        Assign Advisor to Proposal
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          Select advisor to assign the proposal to
        </DialogContentText>
        <FormControl fullWidth className={classes.formControl}>
          <InputLabel>Advisor</InputLabel>
          <Select
            value={advisorId}
            onChange={(e) => setAdvisor(e.target.value)}

          label="Advisor"
          >
            {advisors.map((advisor) => (
              <MenuItem key={advisor.advisorID} value={advisor.advisorID}>
                {advisor.advisorName||"No Name.."}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button
          color="primary"
          onClick={AssignAdvisor}
          disabled={advisorId===null}
        >
          Assign
        </Button>
        <Button
          onClick={onClose}
          color="primary"
        >
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
}
